import React, { ReactElement, FC } from "react";
import { TWBPricing } from "../components/TWBPricing";

const Premium: FC = ({}): ReactElement => {
    return <TWBPricing />;
};

export default Premium;
